
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M5.93007 7.83003L2.28007 11.49C1.50007 12.27 1.50007 13.54 2.28007 14.32L5.94007 17.98C6.72007 18.76 7.99007 18.76 8.77007 17.98L12.4301 14.33C13.2101 13.55 13.2101 12.28 12.4301 11.5L8.76007 7.82003C7.97007 7.04003 6.71007 7.04003 5.93007 7.83003ZM4.40007 12.19L6.65007 9.94003C7.04007 9.55003 7.67007 9.55003 8.07007 9.94003L10.3101 12.18C10.7001 12.57 10.7001 13.2 10.3101 13.59L8.06007 15.84C7.67007 16.23 7.04007 16.23 6.64007 15.84L4.40007 13.61C4.01007 13.22 4.01007 12.58 4.40007 12.19ZM19.3601 6.64003C17.6101 4.88003 15.3001 4.00003 13.0001 4.00003V3.17003C13.0001 2.28003 11.9201 1.83003 11.2901 2.46003L9.47007 4.29003C9.08007 4.68003 9.08007 5.31003 9.47007 5.70003L11.3001 7.53003C11.9201 8.16003 13.0001 7.72003 13.0001 6.83003V6.00003C15.0201 6.00003 17.0301 6.86003 18.4501 8.61003C20.5001 11.13 20.5001 14.88 18.4501 17.4C17.0301 19.14 15.0201 20 13.0001 20C12.2201 20 11.4501 19.87 10.7101 19.61C10.3501 19.49 9.96007 19.6 9.69007 19.87C9.19007 20.37 9.35007 21.26 10.0301 21.49C10.9901 21.83 11.9901 22 13.0001 22C15.3001 22 17.6101 21.12 19.3601 19.36C22.8801 15.85 22.8801 10.15 19.3601 6.64003Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-rotate-90-degrees-ccw`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRotate90DegreesCcw

    ```js
    <b-new-b-icon-rotate-90-degrees-ccw />
    ```
</docs>


